{
	"clickHere": "click here",
	"continueInBrowser": "continue in your browser",
	"notRedirected": "If you weren't redirected,",
	"or": "Or,",
	"redirectingToYourApp": "Redirecting to your {{var0}} app"
}
